import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl
} from "../../../../_metronic/_helpers"
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import SVG from 'react-inlinesvg'
import * as XLSX from 'sheetjs-style'
import { Modal, Button } from 'react-bootstrap'
import Pagination2 from "@material-ui/lab/Pagination";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const EditTargetGroup = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "View Target Group" }));
  const history = useHistory();
  const [titleEN, setTitleEN] = useState('');
  const [titleTH, setTitleTH] = useState('');
  const [descriptionEN, setDescriptionEN] = useState('');
  const [descriptionTH, setDescriptionTH] = useState('');
  const [popupTable, setPopupTable] = useState([])
  const [show, setshow] = useState(false)

  const [start_date, setStart_date] = useState(null);
  const [end_date, setEnd_date] = useState(null);
  const [listGroup2, setListGroup2] = useState([]);

  const [listValue, setListValue] = useState([]);
  const [showListValue, setShowListValue] = useState(false)
  const [showDate, setShowDate] = useState(false)
  const [is_active, setIs_active] = useState(true);
  const [conditions, setConditions] = useState([]);
  const [memberData, setMemberData] = useState([]);
  const [page, setPage] = useState(1);
  const [preview, setPreview] = useState([]);
  const columns_popup = [
    {
      dataField: "key",
      text: "user id",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.ID}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "key",
      text: "firstname",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.firstname}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "value",
      text: "lastname",
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.lastname}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "start_date",
      text: "email",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.email}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "end_date",
      text: "mobile number",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.mobile_number}
            </p>
          </div>
        );
      },
    },
  ]
  const [fixedlist, setfixedList] = useState([
    {
      id: '-',
      created_at: '-',

      key: 'project_id',
      option: null,
      value: [],
      label: 'Project id',
      updated_at: '-',

    },
    {
      id: '-',
      created_at: '-',

      key: 'brand_id',
      option: null,
      value: [],
      label: 'Brand id',
      updated_at: '-',

    }
  ])

  const [projectList, setProjectList] = useState([])
  const [brandList, setBrandtList] = useState([])


  const columns_m = [
    {
      dataField: "key",
      text: "Key",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.label}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "value",
      text: "value",
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.value}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "start_date",
      text: "start date",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.start_date}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "end_date",
      text: "end date",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.end_date}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.status ? 'active' : 'Inactive'}
            </p>
          </div>
        );
      },
    },

  ]
  const handleClose = () => {
    setshow(false)
  }
  const RemoveCondition = (items) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this member !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(async (result) => {
      if (result.value) {
        let temp = memberData
        console.log(memberData, temp)

        console.log('xx', memberData, temp)
        console.log(temp.filter(item => item.key != items.row.key))
        Swal.fire("Deleted!", "Your member has been deleted.", "success");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Your member is safe ", "error");
      }
    });

  };
  const exportExcel = async () => {
    let rows = []
    let temp2 = []
    //let headers = ['USER ID','FIRSTNAME','LASTNAME','EMAIL','DIMENSION','GENDER','BRAND','PROJECT NAME','PROJECT TYPE','FIRST APPROVE DATE']
    let headers = []
    let data2 = {
      USER_ID: groupName.key,
      FIRSTNAME: groupName.label,
      LASTNAME: groupName.label,
      EMAIL: groupName.label,
      DIMENSION: groupName.label,
      GENDER: getShowsplit(value),
      BRAND: start_date,
      PROJECT_NAME: end_date,
      PROJECT_TYPE: is_active,
      FIRST_APPROVE_DATE: is_active,
    }
    await popupTable.map(item => {
      rows.push({
        USER_ID: item.ID,
        FIRSTNAME: item.firstname,
        LASTNAME: item.lastname,
        EMAIL: item.email,
        MOBILE_NUMBER: item.mobile_number,
        /*DIMENSION: item.dimension,
        GENDER: item.gender,
        BRAND: item.brand,
        PROJECT_NAME: item.project_name,
        PROJECT_TYPE: item.project_type,
        FIRST_APPROVE_DATE: item.first_approve_date,*/
      })
    })
    headers = Object.keys(rows[0])
    rows.map(item => {
      let data = []
      headers.map(item2 => {

        data.push(item[item2])
      })

      temp2.push(data)
    })
    const datas = [headers, ...temp2]
    const fileName = `export-ap.xlsx`
    const ws = (XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([[]]))
    const wb = (XLSX.WorkBook = XLSX.utils.book_new())
    const listHeader = ['A1', 'B1', 'C1', 'D1', 'E1']
    XLSX.utils.sheet_add_aoa(ws, datas)
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
    listHeader.map(item => {
      ws[item].s = {
        border: {
          top: {
            style: 'medium',
            color: '000000'
          },
          bottom: {
            style: 'medium',
            color: '000000'
          },
          left: {
            style: 'medium',
            color: '000000'
          },
          right: {
            style: 'medium',
            color: '000000'
          },
        },
        alignment: {
          horizontal: "center"
        },
        font: {
          name: 'angsana new',
          sz: 18,
          bold: true,
        },
        fill: {
          fgColor: {
            rgb: "FFAB00"
          }
        }
      };
    })

    let wscols = [
      { width: 40 },
      { width: 15 },
      { width: 15 },
      { width: 25 },
      { width: 25 },
      { width: 15 },
      { width: 15 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
    ];
    ws["!cols"] = wscols;

    XLSX.writeFile(wb, fileName)
  }
  const handlePageChange = (event, value) => {
    setPage(value);
    //getData(value, limit, search);
  };
  const [groupName, setGroupName] = useState([]);
  const [value, setValue] = useState([]);
  const { user } = useSelector((state) => state.auth);

  const AlertError = (message) => {
    Swal.fire("", message, "error");
  };

  const getPreview = async (previews) => {
    const apiUrls = `${baseURLV1}/targetGroup/preview/user`;
    let token = localStorage.getItem("token");
    let allData = [];
    let temp = []
    await axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        conditions: previews

      },
    })
      .then((res) => {
        console.log(res.data.data)
        const popupTable = popupTable
        res.data.data.map(data => {
          allData.push(data);
        })
        setPopupTable(allData)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  }

  const getListGroup = async () => {
    const apiUrls = `${baseURLV1}/configCondition`;
    let token = localStorage.getItem("token");
    let allData = [];

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        res.data.data.map(data => {
          data = {
            id: data.id,
            created_at: data.created_at,

            key: data.key,
            option: data.option,
            value: data.value,
            label: data.label,
            updated_at: data.updated_at,

          };
          allData.push(data);
        })
        fixedlist.map(item => {
          allData.push(item)
        })
        setListGroup2(allData)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const getBrand = async () => {
    const apiUrls = `${baseURLV1}/brand`;
    let token = localStorage.getItem("token");
    let allData = [];

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        res.data.map(data => {

          allData.push(data);
        })

        setBrandtList(allData)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const getProject = async () => {
    const apiUrls = `${baseURLV1}/project`;
    let token = localStorage.getItem("token");
    let allData = [];

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        res.data.map(data => {

          allData.push(data);
        })

        setProjectList(allData)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const IsJson = (data) => {
    try {
      const text = JSON.parse(data)
      console.log(text)
      if (!text) {
        return false
      }
      return true
    } catch {
      return false
    }
  }

  const getCount =(data)=> {
    if (data%10 > 0) {
      return Math.floor(data / 10) + 1
    } else {
      return Math.floor(data / 10)
    }
  }

  const getData = async () => {
    const apiUrls = `${baseURLV1}/targetGroup/${props.location.state.id}?page=1&limit=10`;
    let token = localStorage.getItem("token");
    let allData = [];
    let allData2 = [];

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then(async (res) => {
        console.log(res.data.conditions[0])
        setTitleEN(res.data.result.title_en)
        setTitleTH(res.data.result.title_th)
        setDescriptionEN(res.data.result.description_en)
        setDescriptionTH(res.data.result.description_th)
        setIs_active(res.data.result.is_active)
        res.data.conditions.map(data => {
          console.log(data, IsJson(data.options))
          let temp = {
            key: data.key,
            label: data.key,
            value: getShowsplit(data.value),
            start_date: IsJson(data.options) ? JSON.parse(data.options).dateFrom : null,
            end_date: IsJson(data.options) ? JSON.parse(data.options).dateTo : null,
            status: res.data.result.is_active,
          }
          let temp2 = {
            key: data.key,
            condition: data.condition,
            value: data.value,
          }
          allData.push(temp)
          allData2.push(temp2)
        })

        setMemberData(allData)
        setPreview(allData2)
        await getPreview(allData2)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };


  useEffect(() => {
    getListGroup()
    getBrand()
    getProject()
    getData()
    //getPreview()
  }, []);

  const getShowsplit = (data) => {
    let string = ''
    data.map(item => {
      if (string == '') {
        string = string + `${item}`
      } else {
        string = string + ` ,${item}`
      }
    })
    return string
  }

  const templateDate = () => {
    //setConditions
    //setConditions([])
    let template = conditions

    let temp = []
    let option = {}
    value.map(item2 => {

      temp.push(item2.value)

    })
    console.log('test', value, groupName.key)

    template.push({
      key: groupName.key,
      condition: '=',
      value: temp,
      ...showDate ? { option: { dateFrom: start_date, dateTo: end_date } } : {}
    })
    //if (checkOption(value)) console.log('option')
    console.log('xa', conditions)
    setConditions(template)

  }

  const onSubmit = async () => {
    let dateFrom = {}
    let dateTo = {}
    let template = []

    console.log(conditions)
    if (titleTH === undefined || titleTH === '') {
      return AlertError("กรุณาใส่ title th !!");
    }
    if (titleEN === undefined || titleEN === '') {
      return AlertError("กรุณาใส่ title en !!");
    }

    /*if (groupName.length == 0 || groupName === undefined) {
      return AlertError("กรุณาใส่ groupName !!");
    }*/

    /*if (value.length == 0 || value === undefined) {
      return AlertError("กรุณาใส่ value !!");
    } else {
      groupName.map(item => {
        let temp = []
        let option = {}

        value.map(item2 => {
          if (item2.key == item.key) {
            temp.push(item2.value)

          }
        })
        template.push({
          key: item.key,
          condition: '=',
          value: temp,
          ...item.option ? { option: { dateFrom: start_date, dateTo: end_date } } : {}
        })
        console.log({
          key: item.key,
          condition: '=',
          value: temp,
          ...item.option ? { option: { dateFrom: start_date, dateTo: end_date } } : {}
        })
        setConditions(template)
      })
    }*/

    if (showDate) {
      if (start_date === undefined || start_date == '') {
        return AlertError("กรุณาใส่ start date !!");
      }
      if (end_date === undefined || end_date == '') {
        return AlertError("กรุณาใส่ end date !!");
      }
    }


    var events = {
      title_th: titleTH,
      title_en: titleEN,
      description_th: descriptionTH,
      description_en: descriptionEN,
      is_active: is_active,
      conditions: conditions
    };

    let apiUrls = `${baseURLV1}/targetGroup`;
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Alert",
          "ไม่สามารถสร้าง Target Group. !! " + err,
          "error"
        );
      });
  };


  return (
    <>
      <Card>
        <CardHeader title="View Target Group"></CardHeader>
        <CardBody>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "ชื่อกลุ่มเป้าหมาย (TH)" })}:{" "}
            </p>
            <input
              disabled
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={titleTH}
              onChange={(e) => setTitleTH(e.target.value)}
            />

          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "ชื่อกลุ่มเป้าหมาย (EN)" })}:{" "}
            </p>
            <input
              disabled
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={titleEN}
              onChange={(e) => setTitleEN(e.target.value)}
            />

          </div>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "รายละเอียดกลุ่มเป้าหมาย (TH)" })}:{" "}
            </p>
            {/*<input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={descriptionTH}
              onChange={(e) => setDescriptionTH(e.target.value)}
            />*/}
            <textarea
              disabled
              name="topic"
              style={{
                //resize: 'none',
                height: "75px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={descriptionTH}
              onChange={(e) => setDescriptionTH(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "รายละเอียดกลุ่มเป้าหมาย (TH)" })}:{" "}
            </p>
            {/*<input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={descriptionEN}
              onChange={(e) => setDescriptionEN(e.target.value)}
            />*/}
            <textarea
              disabled
              name="topic"
              style={{
                //resize: 'none',
                height: "75px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={descriptionEN}
              onChange={(e) => setDescriptionEN(e.target.value)}
            />
          </div>



          {/*<div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "description th" })}:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={descriptionEN}
              onChange={(e) => setDescriptionEN(e.target.value)}
            />
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "description en" })}:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={descriptionTH}
              onChange={(e) => setDescriptionTH(e.target.value)}
            />
          </div>*/}


          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "สถานะการใช้งาน" })}:{" "}
            </p>
            <select name="cars" id="cars"
              disabled
              value={is_active}
              onChange={(e) => {
                console.log(e.target.value)
                setIs_active(e.target.value)
              }}
            >
              <option value={true}>
                Active
              </option>
              <option value={false}>
                InActive
              </option>
            </select>
          </div>

          {showDate ? <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "วันที่เริ่มต้น" })}:{" "}
            </p>

            <TextField
              //disabled={!(!claimNoRef && !isSubmit) || is_reference}
              id="DateFrom"
              type="date"
              label={intl.formatMessage({ id: "###", defaultMessage: "วันที่เริ่มต้น" })}
              className=" mb-3 mr-3"
              value={start_date}
              style={{
                height: '15px',
                //width: '20px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              InputLabelProps={{
                shrink: true
              }}
              onChange={name => {
                setStart_date(name.target.value)
              }}
            />
          </div> : null}

          {showDate ? <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "วันที่สิ้นสุด" })}:{" "}
            </p>

            <TextField
              //disabled={!(!claimNoRef && !isSubmit) || is_reference}
              id="DateFrom"
              type="date"
              label={intl.formatMessage({ id: "###", defaultMessage: "วันที่สิ้นสุด" })}
              className=" mb-3 mr-3"
              value={end_date}
              style={{
                height: '15px',
                //width: '20px',
                backgroundColor: '#F4F6F9',
                borderRadius: '5px',
                borderWidth: '0'
              }}
              InputLabelProps={{
                shrink: true
              }}
              onChange={name => {
                console.log(name.target.value)
                setEnd_date(name.target.value)
              }}
            />
          </div> : null}


          <div className="d-flex justify-content-end mr-3 mb-3">
            {memberData.length > 0 ?
              <div className="d-flex justify-content-between mr-3 ml-3 mt-1">
                <a style={{ color: "#000", fontSize: "16px" }}></a>
                <button className="btn btn-primary" onClick={() => { exportExcel() }}>Export Excel</button>
              </div> : null}
            <div className="d-flex justify-content-between mr-3 ml-3 mt-1">
              <a style={{ color: "#000", fontSize: "16px" }}></a>
              <button className="btn btn-primary" onClick={() => { setshow(true) }}>แสดงกลุ่มผู้ใช้</button>
            </div>
            <a style={{ color: "#000", fontSize: "16px" }}></a>

          </div>
          <div className="m-5">
            <Card>
              <BootstrapTable
                keyField="id"
                data={memberData}
                columns={columns_m}
                wrapperClasses="table-responsive"
                bordered={false}
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
              />
            </Card>
          </div>


          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "80%",
              }}
            ></div>
            <Link to="/TargetGroup">
              <button type="button" className="btn btn-secondary wbt mr-5">
                {intl.formatMessage({ id: "###", defaultMessage: "Back" })}
              </button>
            </Link>
            {/*<button className="btn btn-primary" onClick={() => onSubmit()}>
              {intl.formatMessage({ id: "###", defaultMessage: "Save" })}
            </button>*/}
          </div>
          <Modal show={show} onHide={handleClose} animation={false} size={'lg'}>
            <Modal.Header closeButton>
              <Modal.Title>ตารางกลุ่มผู้ใช้</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="m-5">
                <Card>
                  <BootstrapTable
                    keyField="id"
                    data={popupTable.filter((data, index) => {
                      return data == data && index + 1 > (page * 10) - 10 && index + 1 < (page * 10) + 1
                    })}
                    columns={columns_popup}
                    wrapperClasses="table-responsive"
                    bordered={false}
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                  />
                  <div className=" col-lg-12">
                    <div className="row">
                      {/*<div className="col-lg-6">
                        <div className="mt-3">
                          {"Items per Page: "}
                          <select onChange={handlePageSizeChange} value={10}>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                        </div>
                      </div>*/}
                      <div className="col-lg-6  d-flex align-items-center">
                        <Pagination2
                          className="mt-3 "
                          count={getCount(popupTable.length)}
                          page={page}
                          siblingCount={1}
                          boundaryCount={1}
                          variant="outlined"
                          shape="rounded"
                          onChange={handlePageChange}
                        />
                        <span class="mt-3 ml-5">Result : {popupTable.length} records</span>

                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                ปิด
              </Button>
            </Modal.Footer>
          </Modal>
        </CardBody>
      </Card>
    </>
  );
};
